import i18n from "i18n";
import * as Yup from "yup";

export interface NewGroupFormFields {
  name: string;
  studentEmails?: string[];
}

export const buildNewGroupFormSchema = (): Yup.SchemaOf<NewGroupFormFields> =>
  Yup.object({
    name: Yup.string().required(
      i18n.t("groups:createGroupModal.steps.setGroupDetails.fields.name.errors.required"),
    ),
    studentEmails: Yup.array().of(Yup.string().email()).optional(),
  }).required();
